const o = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" stroke-width="1.5"><path d="M23.25 12.75V6H16.5" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path><path d="m23.25 6-7.939 7.939a1.5 1.5 0 0 1-2.122 0l-3.128-3.128a1.5 1.5 0 0 0-2.122 0L.75 18" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path></svg>';
export {
  o as default
};
